// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
declare let require: any;

export const useHash = false;

// BFF: API and auth are same-origin on the SPA host (Traefik/nginx proxy /api, /auth, … to the backend).
// Branch deploy hostnames embed the slug, so resolve the origin at runtime.
const server_url = window.location.origin;

const auth = {
  loginPath: '/auth/login',
  logoutPath: '/auth/logout',
  sessionPath: '/auth/session',
  resourceServer: {
    allowedUrls: [''],
    sendAccessToken: false,
  },
};

export const environment: EnvConfig = {
  name: 'FrontOffice DEV',
  tenant: 'frontoffice',
  production: false,
  env: 'dev',
  api: '/api/',
  graphql: '/graphql',
  applicationInsightsinstrumentationKey:
    'b6z4pfh5vofyvl5yvueepqv6me3i1o3mm1rtogml',
  version: require('../../package.json').version,
  origins: ['localhost', server_url + '/api', server_url + '/graphql'],
  auth,
  signalR: {
    api: '/',
  },
  instrumentationKey: '7c3066f0-6fac-42dc-9c1f-bf880e984519',
  sentryEnv: 'DevTest',
  enableSentry: true,
};

import { EnvConfig } from '@clean-code/models/common';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
